import { Component, OnInit, AfterViewInit, Output, Input, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { omit } from 'lodash';

@Component({
  selector: 'address-autocomplete',
  templateUrl: './address-autocomplete.component.html',
  styles: []
})
export class AddressAutocompleteComponent implements OnInit, AfterViewInit {
  @Input() tabNum: number;
  @Output() onSelectAddress: EventEmitter<any> = new EventEmitter<any>();
  id: string = 'address-search-' + window['Math'].floor(window['Math'].random() * window['Math'].floor(1000));
  dataForm: FormGroup;
  addressPayload: any;

  constructor(
    private formBuilder: FormBuilder
  ) {
    // create form
    this.dataForm = this.formBuilder.group({
      address: [null]
    });

    // set initial value
    this.addressPayload = this.generatePayloadSeed();
  }

  ngOnInit() {}

  ngAfterViewInit() {
    // select input
    const input = document.getElementById(this.id);

    // create autocomplete
    let autocomplete;
    
    if(window && window['google']){
       autocomplete = new window['google'].maps.places.Autocomplete(input, {
        // restrict the set of place fields.
        fields: ['address_components'],
        // Limit type to specific address.
        types: ['address'],
        // Limit results to the United States and US territories.
        componentRestrictions: { country: ["us", "pr", "vi", "gu", "mp"] }
      });
    } 
   
    // address selection callback
    if(autocomplete) {
      autocomplete.addListener('place_changed', () => {
        // place object returned by service
        const place = autocomplete.getPlace();
  
        const addressComponents = place.address_components || [];
  
        // prepare payload
        this.addressPayload = this.generatePayloadSeed();
  
        // build payload and add values
        this.buildPayload(addressComponents);
        
        // update city value
        this.addressPayload.City = this.addressPayload.City || this.addressPayload.CityAlt1 || this.addressPayload.CityAlt2 || this.addressPayload.CityAlt3;
  
        // send to parent
        const updatedPayload = omit(this.addressPayload, ['CityAlt1', 'CityAlt2', 'CityAlt3']);
        this.onSelectAddress.emit(updatedPayload);
      });
    }
   
  }

  generatePayloadSeed() {
    return {
      Street: '',
      City: '',
      State: '',
      Zip: '',
      CityAlt1: '',
      CityAlt2: '',
      CityAlt3: ''
    };
  }      

  buildPayload(addressComponents: any) {
    addressComponents.forEach((value: any, index: any) => {
      if (value.types[0] === 'street_number') {
        this.addressPayload.Street = value.long_name;
      }

      if (value.types[0] === 'route') {
        this.addressPayload.Street += ' ' + value.long_name;
      }

      if (value.types[0] === 'locality') {
        this.addressPayload.City = value.long_name;
      }

      if (value.types[0] === 'neighborhood') {
        this.addressPayload.CityAlt1 = value.long_name;
      }

      if (value.types[0] === 'sublocality_level_1') {
        this.addressPayload.CityAlt2 = value.long_name;
      }

      if (value.types[0] === 'administrative_area_level_3') {
        this.addressPayload.CityAlt3 = value.long_name;
      }

      if (value.types[0] === 'administrative_area_level_1') {
        this.addressPayload.State = value.short_name;
      }

      if (value.types[0] === 'postal_code') {
        this.addressPayload.Zip = value.long_name;
      }
    });
  }      
}
